// extracted by mini-css-extract-plugin
module.exports = {"idCaption":"ConfigurarCategorias_idCaption__2Eg35","categoriaInput":"ConfigurarCategorias_categoriaInput__34TXN","actionButtons":"ConfigurarCategorias_actionButtons__9n_pl"};